import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-excel-export',
  templateUrl: './excel-export.component.html',
  styleUrls: ['./excel-export.component.css']
})
export class ExcelExportComponent implements OnInit {
  @Input() formName: string
  @Input() formTitle: string 
  filename: string
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.filename = this.formName;
  }

  export() {
    this.activeModal.close(this.filename);
  }

  closeModal() {
    this.activeModal.close(null);
  }
}
